'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this component exists for the stepper
var HalfCircle = function HalfCircle(_ref) {
  var width = _ref.width,
      className = _ref.className,
      color = _ref.color,
      outline = _ref.outline,
      backgroundColor = _ref.backgroundColor,
      direction = _ref.direction;

  var directions = {
    top: 90,
    left: 0,
    bottom: 270,
    right: 180
  };
  return _react2.default.createElement(
    'svg',
    {
      className: className,
      width: width,
      height: width,
      viewBox: '0 0 24 24',
      transform: 'rotate(' + directions[direction] + ')' },
    _react2.default.createElement('path', { fill: color, d: 'M11.9,0H12V24h-.1a12,12,0,0,1,0-24Z', transform: 'translate(0 0.02)' }),
    _react2.default.createElement('path', { fill: backgroundColor, d: 'M12.1,0H12V24h.1a12,12,0,0,0,0-24Z', transform: 'translate(0 0.02)' }),
    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '12', fill: 'none', stroke: outline })
  );
};

HalfCircle.propTypes = {
  color: _propTypes2.default.string,
  backgroundColor: _propTypes2.default.string,
  className: _propTypes2.default.string,
  outline: _propTypes2.default.string,
  direction: _propTypes2.default.oneOf(['top', 'left', 'bottom', 'right']),
  width: _propTypes2.default.number
};

HalfCircle.defaultProps = {
  color: '',
  backgroundColor: 'white',
  className: 'default',
  outline: _colors.alloy,
  direction: 'left',
  width: 14
};

exports.default = HalfCircle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cimpress/react-components/lib/shapes/HalfCircle.js
// module id = 484
// module chunks = 0